import { AdDetails } from '@/api/types/ads.types';
import { AdStatus } from '@/types';
import { CategoryBaseInfo } from '@/api/types/categories.types';
import { useServerDataContext } from '@/contexts';
import { useAdDetails } from '@/hooks/useAdDetails';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';

export type AdBaseData = {
  adData: AdDetails | null;
  loading: boolean;
  status?: AdStatus;
  currentCategory?: CategoryBaseInfo;
  hasClientAdNotFoundError: boolean;
};

export function useAdBaseData(): AdBaseData {
  const { initialAdDetails } = useServerDataContext();
  const {
    adDetails,
    loading,
    hasAdNotFoundError: hasClientAdNotFoundError,
  } = useAdDetails();
  const { currentCategory } = useCurrentCategory();

  const adData = adDetails ?? initialAdDetails;
  const status = adData?.status;

  return {
    adData,
    loading,
    status,
    currentCategory,
    hasClientAdNotFoundError,
  };
}
